export const ANNOTATIONS_TYPES_FETCHED = 'ANNOTATIONS_TYPES_FETCHED';
export const ANNOTATIONS_TYPES_REMOVE = 'ANNOTATIONS_TYPES_REMOVE';
